module.exports = __webpack_public_path__ + "static/media/dashboard-placeholder-icon.ff9e3759.svg";